enum KeyCode {
  KeyEnter = 'Enter',
}

export default KeyCode;
